import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ThemeProvider } from "@/lib/themeContext";
import "./index.css";

// Capture auth callback type from URL before Supabase initializes and clears the hash.
// This runs synchronously before React or Supabase touches anything.
try {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const search = new URLSearchParams(window.location.search);
  const type = search.get("type") || hash.get("type");
  if (type === "recovery" || type === "invite") {
    sessionStorage.setItem("_auth_callback_type", type);
  }
} catch (_) {}

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ThemeProvider>
  </ErrorBoundary>
);
